import { AI_DISCLAIMER } from "helpers/ai"
import { useAiTeammateContext, useMessagesContext } from "connected-components/ai-teammate/hooks/context"
import AiTeammateMessagesPanel from "connected-components/ai-teammate/components/messages-panel"
import AiTeammateMessageInput from "connected-components/ai-teammate/components/message-input"
import AiTeammateFetchingProgress from "connected-components/ai-teammate/components/fetching-progress"
import ChatPromptSuggestions from "./prompt-suggestions"

export default function ChatThreadRegion() {
  const { isFetching, hasMessages, dispatchUserMessageInputOverride } = useMessagesContext()
  const { hasError } = useAiTeammateContext()
  // The messages panel is what renders a fetch error; show it on error too, not only when messages
  // exist — otherwise a failed load silently falls back to the starter prompts.
  const showConversation = hasMessages || hasError

  return <div className="agent-chat-thread">
    {/* The reused message / messages-panel styles are scoped under `.connected-components_ai-teammate`,
        so the conversation carries that root class for the message + avatar layout to apply here. */}
    <div className="chat-conversation connected-components_ai-teammate">
      {showConversation ? <AiTeammateMessagesPanel /> : <ChatPromptSuggestions onPick={dispatchUserMessageInputOverride} />}
    </div>
    <div className="chat-composer">
      <AiTeammateFetchingProgress isFetching={isFetching} />
      <AiTeammateMessageInput />
      <div className="ai-teammate-footer">{AI_DISCLAIMER}</div>
    </div>
  </div>
}
